/* Dedicated header scroll-state toggler — independent of drawer/other JS.
   Adds .lux-header-at-top when near the top (transparent state),
   removes it when scrolled (solid state). */
(function () {
  'use strict';
  var body = document.body;
  var THRESHOLD = 24;
  var ticking = false;

  function update() {
    var y = window.scrollY || window.pageYOffset || 0;
    body.classList.toggle('lux-header-at-top', y < THRESHOLD);
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });

  window.addEventListener('resize', update, { passive: true });
  document.addEventListener('shopify:section:load', update);

  update(); // run immediately

  // When the menu drawer closes (menu-open removed), ensure the sticky header
  // isn't left stuck in its hidden state.
  var sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    var hadMenuOpen = sectionHeader.classList.contains('menu-open');
    new MutationObserver(function () {
      var nowOpen = sectionHeader.classList.contains('menu-open');
      if (hadMenuOpen && !nowOpen) {
        sectionHeader.classList.remove('shopify-section-header-hidden');
      }
      hadMenuOpen = nowOpen;
    }).observe(sectionHeader, { attributes: true, attributeFilter: ['class'] });
  }
  
})();